export const MISSION_PREFERENCES_OPTALL = "missionPreferenceOptAll";
export const REGISTRATION_TOUCHPOINT = "New Account Registration";
export const CPM_YES = "1";
export const CPM_NO = "0";
export const CPM_CONSENT_NO = "N";
export const CPM_CONSENT_YES = "Y";
export const UNDEFINED = "undefined";
